'use strict';

$(function () {
    if ($('#end_date_value').val() !== '') {

        var date_now = new Date();
        var date_future = $('#end_date_value').val();

        date_future = new Date(date_future);

        var delta = (date_future - date_now) / 1000;

        if (delta >= 0) {
            var days = Math.floor(delta / 86400);
            delta -= days * 86400;

            var hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;

            var minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;

            var seconds = delta % 60;

            var dateObj = {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            }

            function getCounterData(dateObj) {
                var days = parseInt(dateObj.days);
                var hours = parseInt(dateObj.hours);
                var minutes = parseInt(dateObj.minutes);
                var seconds = parseInt(dateObj.seconds);
                return seconds + (minutes * 60) + (hours * 3600) + (days * 3600 * 24);
            }

            function setCounterData(s) {
                var days = Math.floor(s / (3600 * 24));
                var hours = Math.floor((s % (60 * 60 * 24)) / (3600));
                var minutes = Math.floor((s % (60 * 60)) / 60);
                var seconds = Math.floor(s % 60);

                $('.e-m-days').html(String(days).padStart(2, '0'));
                $('.e-m-hours').html(String(hours).padStart(2, '0'));
                $('.e-m-minutes').html(String(minutes).padStart(2, '0'));
                $('.e-m-seconds').html(String(seconds).padStart(2, '0'));
                $('.LSHOP-banner-component .count-down-timer').removeClass('d-none')
            }

            var count = getCounterData(dateObj);

            var timer = setInterval(function () {
                count--;
                if (count == 0) {
                    clearInterval(timer);
                    $('.LSHOP-banner-component .count-down-timer').addClass('d-none');
                    $('.LSHOP-banner-component .js-btn-save-date').addClass('d-none');
                    $('.LSHOP-banner-component .js-btn-replay').removeClass('d-none');
                    return;
                }
                setCounterData(count);
            }, 1000);
        } else {
            $('.LSHOP-banner-component .js-btn-save-date').addClass('d-none');
            $('.LSHOP-banner-component .js-btn-replay').removeClass('d-none');
        }
    }
});